import messageApi from '@/api/messages/list';
import * as StorageService from '@/util/StorageService';

const state = {
    unapproveCount: 0,
    hideUnapproveCount: false,
};

const getters = {
    hasUnapproveCount(state) {
        return state.unapproveCount > 0 && !state.hideUnapproveCount;
    }
}

const mutations = {
    unapproveCountSet(state, count) {
        state.unapproveCount = count;
    },
    hideUnapproveCount(state) {
        state.hideUnapproveCount = true;
    },
}

const actions = {
    async ['initUnapproveCount']({
        commit
    }){
        let preTaskDate = StorageService.getItem(StorageService.keys.MyTaskActionDate);
        if(preTaskDate != moment(new Date()).format('YYYY-MM-DD')) {
            //上次进入我的任务不是当天，才刷新未处理任务
            const count = await messageApi.getUnApproveCount({});

            commit('unapproveCountSet', count);
        }
        else {
            commit('hideUnapproveCount');
        }        
    },
    hideUnapproveCount({commit}) {
        commit('hideUnapproveCount');
    }
}


export default {
    state,
    getters,
    mutations,
    actions
  };


// WEBPACK FOOTER //
// ./src/store/modules/unapprove.js